import styled from 'styled-components'

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    h1{
        font-size: 32px;
        font-weight: 400;

        margin-bottom: 1rem;
    }
`


export const BadgeImg = styled.img`

`